import type { CSSProperties } from 'react';
import type { GameRound } from './engine';

const palettes = [
  ['#fbdf89', '#fb916a'],
  ['#e4ffb5', '#85dbc5'],
  ['#e7d5ff', '#bc9cfa'],
  ['#c7f3ff', '#7db8f2'],
  ['#ffe0ef', '#f49bb6'],
  ['#fff2cc', '#e6ca9b'],
];

// Independent from chart randomness; the same saved round renders identically
// in the card, queue, sidebar and after a reload. No network generation.
export function artVariant(seed: number) {
  const value = Math.imul(seed ^ 0x45d9f3b, 0x27d4eb2d) >>> 0;
  return {
    palette: value % palettes.length,
    pattern: Math.floor(value / 6) % 4,
    flipped: (value & 256) !== 0,
    tilt: [-5, 0, 5][Math.floor(value / 24) % 3],
  };
}

export function HybridArt({
  round,
  className = '',
  name,
}: {
  round: Pick<GameRound, 'seed' | 'image'>;
  className?: string;
  name: string;
}) {
  const variant = artVariant(round.seed);
  const [light, dark] = palettes[variant.palette];
  return (
    <span
      className={`token-art hybrid-art hybrid-pattern-${variant.pattern} ${className}`}
      role="img"
      aria-label={`${name} · AI game token`}
      style={{ '--art-light': light, '--art-dark': dark } as CSSProperties}
    >
      <img
        src={round.image}
        alt=""
        draggable={false}
        style={{
          transform: `rotate(${variant.tilt}deg) scaleX(${variant.flipped ? -1 : 1})`,
        }}
      />
    </span>
  );
}
